import React, { useEffect, useRef, useState } from "react";
import "./header.css";
import logo from "../../../assets/logo-PNG.png";
import { API } from "../../../config/api";
import { GET, POST } from "../../../utils/apicalls";
import { SearchOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { Form, Select } from "antd";
const Header: React.FC = () => {
    const [menuOpen, setMenuOpen] = useState(false);
    const [isSticky, setIsSticky] = useState(false);
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const toggleRef = useRef<HTMLDivElement>(null);
    const menuRef = useRef<HTMLDivElement>(null);
    const navigate = useNavigate();
    const [form1] = Form.useForm();

    useEffect(() => {
        const handleScroll = () => {
            setIsSticky(window.scrollY > 50);
        };
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            const target = event.target as Node;

            if (
                (menuRef.current && !menuRef.current.contains(target)) &&
                (toggleRef.current && !toggleRef.current.contains(target))
            ) {
                setMenuOpen(false);
                setSidebarOpen(false);
            }
        };

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [menuOpen, sidebarOpen]);

    const closeAll = () => {
        setMenuOpen(false);
        setSidebarOpen(false);
    };
    const [isLoading, setIsLoading] = useState(false);

    const [CourseFilterData, setCourseFilterData] = useState<any[]>([]);
    const [isSearchModalOpen, setIsSearchModalOpen] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");
    const [allCourseData, setallCourseData] = useState<any>([]);

    const feacthAllCourse = async () => {
        try {
            setIsLoading(true);
            const response: any = await GET(API.GET_ALL_COURSES, {});
            setallCourseData(response?.data);
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        feacthAllCourse();
    }, []);

    // Keyword-based matching (in order)
    const courseKeywordOrder = [
        { key: "EA", keyword: "enrolled agent" },
        { key: "CFM", keyword: "finance manager" },
        { key: "CFS", keyword: "finance specialist" },
        { key: "IFRS", keyword: "ifrs" },
        // { key: "NDT", keyword: "non-destructive" },
        { key: "CFE", keyword: "certified fraud examiner " }
    ];

    // Normalize helper
    const normalize = (str: string) =>
        str.toLowerCase().replace(/[™®]/g, "").trim();

    // Match ordered courses
    const orderedCourses = courseKeywordOrder
        .map(({ keyword }) => {
            const course = allCourseData?.find((c: any) =>
                normalize(c.course_title).includes(keyword)
            );
            return course
                ? {
                    value: course.id,
                    label: course.course_title
                }
                : null;
        })
        .filter((item): item is { value: number; label: string } => !!item);

    // Add remaining unmatched courses
    const remainingCourses =
        allCourseData
            ?.filter(
                (c: any) =>
                    !orderedCourses.some((oc) => oc.value === c.id)
            )
            .map((c: any) => ({
                value: c.id,
                label: c.course_title
            })) || [];

    const orderedOptions = [...orderedCourses, ...remainingCourses];


    const handleCourseSelect = (id: number) => {
        if (id) {
            navigate(`/course/${id}`);
            setIsSearchModalOpen(false); // Close modal after navigation
        }
    };
    return (
        <>
            <div className="header-wrapper">

                <div className="main-header">
                    <div className="header-top-wrapper">
                        <div className="left-color"></div>
                        <div className="center-content">Your Content Here</div>
                        <div className="right-color"></div>
                    </div>
                    <header className={`header-nav-wrapper ${isSticky ? "sticky" : ""}`}>
                        <div className="logo">
                            <img src={logo} alt="Meantoir Global Academy™" />
                            <div>
                                <b className="logo-title">Meantoir Global Academy™</b><br />
                                <span className="logo-tagline">Your Pass, Our Promise</span>
                            </div>

                        </div>



                        <nav className={`nav-bar1 ${menuOpen ? "open" : ""}`} ref={menuRef}>
                            <ul>
                                <li><a href="/" className="nav-link">Home</a></li>
                                <li><a href="/about-us" className="nav-link">About Us</a></li>
                                <li><a href="/course" className="nav-link">Courses</a></li>
                                <li><a href="/blogs" className="nav-link">Blogs</a></li>
                                <li><a href="/contact" className="nav-link">Contact</a></li>
                                <li>
                                    <span
                                        className="search-icon"
                                        onClick={() => setIsSearchModalOpen(true)}
                                        style={{ cursor: 'pointer', color: 'black', fontSize: '20px' }}
                                    >
                                        <SearchOutlined />
                                    </span>


                                </li>

                                <li>
                                    <button
                                        onClick={() => setSidebarOpen(true)}
                                        className="nav-link"
                                        style={{ background: "none", border: "none", cursor: "pointer", }}
                                    >
                                        ☰
                                    </button>
                                </li>

                            </ul>
                        </nav>

                        <div className="menu-toggle" onClick={() => setMenuOpen(!menuOpen)} ref={toggleRef}>
                            ☰
                        </div>
                    </header>
                </div>
                {isSearchModalOpen && (
                    <div className="search-modal-overlay" onClick={() => setIsSearchModalOpen(false)}>
                        <div className="search-modal-box" onClick={(e) => e.stopPropagation()}>
                            <button className="close-btn" onClick={() => setIsSearchModalOpen(false)}>×</button>

                            <Select
                                placeholder="Select Course"
                                allowClear
                                showSearch
                                style={{ width: 200 }}
                                options={orderedOptions}
                                onChange={handleCourseSelect}
                            />

                        </div>
                    </div>
                )}     {isSearchModalOpen && (
                    <div className="search-modal-overlay" onClick={() => setIsSearchModalOpen(false)}>
                        <div className="search-modal-box" onClick={(e) => e.stopPropagation()}>
                            <button className="close-btn" onClick={() => setIsSearchModalOpen(false)}>×</button>

                            <Select
                                placeholder="Select Course"
                                allowClear
                                showSearch
                                style={{ width: 200 }}
                                options={orderedOptions}
                                onChange={handleCourseSelect}
                            />

                        </div>
                    </div>
                )}


            </div>
            {(menuOpen || sidebarOpen) && (
                <div
                    className="overlay"
                    onClick={closeAll}
                    role="button"
                    aria-label="Close menu"
                    tabIndex={0}
                />
            )}


            <div className={`sidebar ${sidebarOpen ? 'open' : ''}`} ref={toggleRef}>
                <div className="sidebar-header">
                    <button
                        className="close-sidebar"
                        onClick={() => setSidebarOpen(false)}
                        aria-label="Close policies sidebar"
                        style={{ background: "none", border: "none", cursor: "pointer", fontSize: "24px" }}
                    >
                        ×
                    </button>
                    <h2>Policies</h2>
                </div>
                <div className="sidebar-content">
                    <div className="policy-section">
                        <h3>Terms and Conditions</h3>
                        <p>Your privacy is important to us. We do not share your data with third parties without your consent. <a href="/privacy" style={{ color: "blue" }}>Read More</a></p>
                    </div>
                    <div className="policy-section">
                        <h3>Refund Policy</h3>
                        <p>Refunds are available within 7 days of purchase. Contact support for assistance. <a href="/refund" style={{ color: "blue" }}>Read More</a></p>
                    </div>
                </div>
            </div>

        </>
    );
};

export default Header;
